// Semantic color tokens (Duolingo-style)
//
// Each color in this palette permanently represents one concept across the
// entire app. The goal is that students learn the visual language: orange
// always means "streak", purple always means "AI", teal always means
// "entries", and so on. Consistency builds intuition — when a user sees a
// purple chip anywhere in the product, they know it is AI-related without
// reading the label.
//
// All `primary` shades are tested for WCAG AA contrast (>= 4.5:1) against a
// white (#ffffff) background, so they are safe to use for icon glyphs, small
// text, or 4px accent stripes on white cards. `light` shades are intended
// for subtle backgrounds / tints (icon circles, chip fills). `dark` shades
// are intended for hover / pressed states or text on top of `light`.
//
// New pages should import from this module rather than hard-coding hex
// values. Existing pages will adopt the tokens incrementally as they are
// touched (see T03 for the rollout plan).

export const SEMANTIC_COLORS = {
  // Journal entries — the core "writing" surface of the product.
  entries: { primary: '#01696F', light: '#e0f2f1', dark: '#004d52' },

  // Streaks, weekly goal, time-based motivation.
  streak: { primary: '#f59e0b', light: '#fef3c7', dark: '#92400e' },

  // Activities (clubs, sports, jobs, internships).
  activities: { primary: '#2563eb', light: '#dbeafe', dark: '#1e40af' },

  // AI-powered features (auto-tag, brainstorm, resume bullets, etc.).
  ai: { primary: '#7c3aed', light: '#ede9fe', dark: '#5b21b6' },

  // Awards, honors, recognitions.
  awards: { primary: '#d97706', light: '#fed7aa', dark: '#92400e' },
};

export default SEMANTIC_COLORS;
